import Vue from 'vue';
import Driver from 'driver.js';

const VueDriver = {
  steps: [],
  driver: null,
};

VueDriver.install = function install(VueArg) {
  VueDriver.driver = new Driver({});

  VueArg.directive('driver-step', {
    bind(el, binding) {
      const step = {
        element: el,
        popover: {
          ...(binding.value ? (binding.value.popover || {}) : {}),
        },
      };
      if (binding.value && binding.value.index != null) {
        VueDriver.steps.splice(binding.value.index, 0, step);
      } else {
        VueDriver.steps.push(step);
      }
      if (binding.value && binding.value.onclick === true) {
        el.onclick = () => VueDriver.driver.highlight(step);
      }
    },
  });

  VueArg.prototype.$driver = VueDriver.driver;
  VueArg.prototype.$startTour = (index) => {
    VueArg.nextTick(() => {
      VueDriver.driver.defineSteps([...VueDriver.steps]);
      VueDriver.driver.start(index);
    });
  };
};

Vue.use(VueDriver);



// WEBPACK FOOTER //
// ./src/plugins/driver.js